import React, { useState, useEffect } from 'react';
import InstituteDashboard from './InstituteDashboard';

const DeleteExternalDegree = () => {
    const [externalDegrees, setExternalDegrees] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');

    useEffect(() => {
        fetchDeletedExternalDegrees();
    }, []);

    const fetchDeletedExternalDegrees = async () => {
        try {
            const response = await fetch('https://api.myskills.lk/externalDegree/deleted');
            const data = await response.json();
            setExternalDegrees(data);
        } catch (error) {
            console.error('Error fetching deleted external degrees:', error);
        }
    };

    const handleRestore = async (id) => {
        try {
            const response = await fetch(`https://api.myskills.lk/externalDegree/restore/${id}`, {
                method: 'POST'
            });
            if (response.ok) {
                setExternalDegrees(prev => prev.filter(degree => degree.id !== id));
                window.alert('External Degree Restored');
            } else {
                console.error('Failed to restore external degree');
            }
        } catch (error) {
            console.error('Error restoring external degree:', error);
        }
    };

    const handlePermanentDelete = async (id) => {
        try {
            const response = await fetch(`https://api.myskills.lk/externalDegree/delete/permanent/${id}`, {
                method: 'DELETE'
            });
            if (response.ok) {
                setExternalDegrees(prev => prev.filter(degree => degree.id !== id));
                window.alert('External Degree permanently deleted');
            } else {
                console.error('Failed to permanently delete external degree');
            }
        } catch (error) {
            console.error('Error permanently deleting external degree:', error);
        }
    };

    const filteredDegrees = externalDegrees.filter(degree =>
        degree.courseName.toLowerCase().includes(searchTerm.toLowerCase())
    );

    return (
        <div>
            <InstituteDashboard />
            <div className='AllViews-admin-course'>
                <div className="search-icon-admin admin-course-search">
                    <h1>DELETE EXTERNAL DEGREES</h1>
                    <form onSubmit={(e) => e.preventDefault()}>
                        <input
                            type="text"
                            placeholder="Search by Name"
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                        />
                        <input type="submit" value="SEARCH" />
                    </form>
                </div>

                <div className="scroller-box">
                    <div className="table-course">
                        <table>
                            <thead>
                            <tr>
                                <th>External Degree Name</th>
                                <th>Institute Name</th>
                                <th>Start Date</th>
                                <th>Duration</th>
                                <th>View</th>
                                <th>Actions</th>
                            </tr>
                            </thead>
                            <tbody>
                            {filteredDegrees.length > 0 ? (
                                filteredDegrees.map((degree) => (
                                    <tr key={degree.id}>
                                        <td>{degree.courseName}</td>
                                        <td>{degree.university}</td>
                                        <td>{new Date(degree.startDate).toLocaleDateString('en-CA')}</td>
                                        <td>{degree.duration}</td>
                                        <td>
                                            {degree.instituteLocation ? (
                                                <a href={degree.instituteLocation} target="_blank" rel="noopener noreferrer" id="view-web">
                                                    WEBSITE
                                                </a>
                                            ) : 'N/A'}
                                        </td>
                                        <td id="action-buttons">
                                            <a href="#!" id="restore-details" onClick={() => handleRestore(degree.id)}>RESTORE</a>
                                            <a href="#!" id="del-details" onClick={() => handlePermanentDelete(degree.id)}>DELETE</a>
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr><td colSpan={6} style={{ textAlign: 'center' }}>No deleted external degrees found.</td></tr>
                            )}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DeleteExternalDegree;
